'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameManager = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _index = require('../create-emotion/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var FrameManager = exports.FrameManager = function () {
  function FrameManager() {
    _classCallCheck(this, FrameManager);

    this.emotionInstances = [];
    this.frames = new Set();
  }

  _createClass(FrameManager, [{
    key: 'getIndex',
    value: function getIndex(frame) {
      return [].concat(_toConsumableArray(this.frames)).indexOf(frame);
    }
  }, {
    key: 'getEmotionNamespace',
    value: function getEmotionNamespace() {
      return '__EMOTION_FRAMED_' + this.frames.size + '__';
    }
  }, {
    key: 'createNewEmotionFromFrame',
    value: function createNewEmotionFromFrame(frame) {
      var newEmotion = (0, _index2.default)(_defineProperty({}, this.getEmotionNamespace(), {}), {
        container: frame.head
      });
      this.frames.add(frame);
      this.emotionInstances.push(newEmotion);
      return newEmotion;
    }
  }, {
    key: 'getEmotion',
    value: function getEmotion(frame) {
      if (!frame) return {};
      var emotionInstance = void 0; // This try/catch was added for IE11/Edge.
      // These browsers throw an error if an attempt was made to on an iFrame
      // that no longer exists (SCRIPT70 errors). This occurs when iFrames are
      // unmounted/destroyed.

      try {
        var index = this.getIndex(frame);

        if (index >= 0) {
          emotionInstance = this.emotionInstances[index];
        } else {
          emotionInstance = this.createNewEmotionFromFrame(frame);
        }
      } catch (e) {
        /* istanbul ignore next */
        emotionInstance = this.createNewEmotionFromFrame(frame);
      }

      return emotionInstance;
    }
  }]);

  return FrameManager;
}();

var createFrameManager = function createFrameManager() {
  return new FrameManager();
};

exports.default = createFrameManager;